// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import slide1 from '../assets/slide1.JPG';
import slide2 from '../assets/slide2.JPG';
import slide3 from '../assets/slide3.PNG';
import slide4 from '../assets/slide4.JPG';
import slide5 from '../assets/slide5.JPG';
import slide6 from '../assets/slide6.JPG';
import slide7 from '../assets/slide7.JPG';
import slide8 from '../assets/slide8.JPG';
import slide9 from '../assets/slide9.JPG';
import slide10 from '../assets/slide10.JPG';
import slide11 from '../assets/slide11.PNG';
import slide12 from '../assets/slide12.PNG';
import slide13 from '../assets/slide13.JPG';
import slide14 from '../assets/slide14.jpg';
import slide15 from '../assets/slide15.JPG';
import slide16 from '../assets/slide16.jpg';
import slide17 from '../assets/slide17.PNG';
import slide18 from '../assets/slide18.JPG';
import slide19 from '../assets/slide19.jpg';
import slide20 from '../assets/slide20.JPG';
import slide21 from '../assets/slide21.PNG';

import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

function Projects() {
  const projectImages = [
    {
      id: 1,
      src: slide1,
      alt: 'Project 1',
    },
    {
      id: 2,
      src: slide2,
      alt: 'Project 2',
    },
    {
      id: 3,
      src: slide3,
      alt: 'Project 3',
    },
    {
      id: 4,
      src: slide4,
      alt: 'Project 4',
    },
    {
      id: 5,
      src: slide5,
      alt: 'Project 5',
    },
    {
      id: 6,
      src: slide6,
      alt: 'Project 6',
    },
    {
      id: 7,
      src: slide7,
      alt: 'Project 7',
    },
    {
      id: 8,
      src: slide8,
      alt: 'Project 8',
    },
    {
      id: 9,
      src: slide9,
      alt: 'Project 9',
    },
    {
      id: 10,
      src: slide10,
      alt: 'Project 10',
    },
    {
      id: 11,
      src: slide11,
      alt: 'Project 11',
    },
    {
      id: 12,
      src: slide12,
      alt: 'Project 12',
    },
    {
      id: 13,
      src: slide13,
      alt: 'Project 13',
    },
    {
      id: 14,
      src: slide14,
      alt: 'Project 14',
    },
    {
      id: 15,
      src: slide15,
      alt: 'Project 15',
    },
    {
      id: 16,
      src: slide16,
      alt: 'Project 16',
    },
    {
      id: 17,
      src: slide17,
      alt: 'Project 17',
    },
    {
      id: 18,
      src: slide18,
      alt: 'Project 18',
    },
    {
      id: 19,
      src: slide19,
      alt: 'Project 19',
    },
    {
      id: 20,
      src: slide20,
      alt: 'Project 20',
    },
    {
      id: 21,
      src: slide21,
      alt: 'Project 21',
    },
  ];

  return (
    <div className="w-full flex flex-col items-center justify-center py-12 bg-white">
      {/* Header */}
      <div className="mb-8 md:mb-6">
        <p
          id="Projects"
          className="font-bold text-4xl md:text-5xl text-center mb-2 md:mb-4"
        >
          Our <span className="text-orange-500">Projects</span>
        </p>
        <hr className="border-1 border-[#FFA500] w-20 mx-auto rounded-md" />
      </div>

      {/* Image Slider */}
      <div className="w-[80%] md:w-[80%] max-w-4xl mb-6 md:mb-6 md:mt-4">
        <Swiper
          cssMode={true}
          navigation={true}
          pagination={true}
          mousewheel={true}
          keyboard={true}
          modules={[Navigation, Pagination, Mousewheel, Keyboard]}
          className="rounded-lg overflow-hidden shadow-lg h-[270px] md:h-[500px]"
        >
          {projectImages.map(image => (
            <SwiperSlide key={image.id} className="">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-[270px] md:h-[500px] object-contain"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="flex justify-center mt-10">
        <a
          href="https://www.instagram.com/superhandyhome/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#FFA500] rounded-sm text-white px-6 py-3 shadow-black shadow-sm hover:bg-orange-500"
        >
          See More Before & After Photos
        </a>
      </div>
    </div>
  );
}

export default Projects;
